import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SparkApi from "../../api/SparkApi";
import { Oval } from 'react-loader-spinner'
import { useExtract } from "../layout/Main";
import imageCompression from 'browser-image-compression';

const CreateProducts = () => {
  const { setIsExtract } = useExtract();
  const location = useLocation();
  const navigate = useNavigate();
  const formRef = useRef();
  const paramId = useParams();
  const [productCategoriesOptions, setProductCategoriesOptions] = useState([]);
  const [products, setProducts] = useState({
    name: "",
    quantity: 0,
    description: "",
    status: "Available",
    company_name: "",
    imagePath: "",
    category_id: null,
    title: null,
    type: "",
    rack_id: location.state?.id ? location.state?.id : null,
  });
  const [selectedfiles, setSelectedFiles] = useState([]);
  const [isExtractImage, setIsExtractImage] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [isExtracting, setIsExtracting] = useState(false);

  useEffect(() => {
    const fetchAllProductCategory = async () => {
      try {
        const productCategories = await SparkApi.getProductCategory();
        const productCategoryRecords = productCategories?.records.map(
          (sub) => ({
            value: sub.id,
            label: sub.category,
            status: sub.status,
          })
        );
        setProductCategoriesOptions(productCategoryRecords);
      } catch (error) {
        console.error("Error fetching product categories:", error);
      }
    };

    fetchAllProductCategory();

    if (location?.state?.editProductData) {
      setProducts(location?.state?.editProductData);
    }
  }, []);

  const handleCancel = () => {
    products?.id
      ? navigate(`/productview/${products?.id}`, { state: products })
      : navigate("/products");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProducts((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      if (!products.name.trim() || !products.status) {
        return toast.error("Missing required fields");
      }
      setDisableButton(true)

      let result = null;
      if (products.id) {
        result = await SparkApi.saveProduct(products);

        if (selectedfiles.length > 0 && result.success) {
          // Upload all new files (keep existing ones — user can delete from the view)
          const recordId = result?.updatedProduct.id;
          for (const file of selectedfiles) {
            const formData = new FormData();
            formData.append("image", file);
            await SparkApi.createFile(recordId, formData);
          }
          toast.success(result.message);
          setTimeout(() => {
            setDisableButton(false);
            navigate(`/productview/${result.updatedProduct.id}`, {
              state: result.updatedProduct,
            });
          }, 900);
        } else {
          if (result.success) {
            toast.success(result.message);
            setTimeout(() => {
              setDisableButton(false);
              navigate(`/productview/${result.updatedProduct.id}`, {
                state: result.updatedProduct,
              });
            }, 900);
          }
        }
      } else {
        result = await SparkApi.createProduct(products);

        if (result?.success) {
          const recordId = result?.records?.id;
          // Upload all selected files
          for (const file of selectedfiles) {
            const formData = new FormData();
            formData.append("image", file);
            await SparkApi.createFile(recordId, formData);
          }
          toast.success("Product created successfully");
          setTimeout(() => {
            setDisableButton(false);
            if (location.state?.id) {
              navigate(`/rack/${location.state?.id}`);
            } else {
              navigate(`/products`);
            }
          }, 2000);
        } else {
          console.error("Internal Server Error");
        }
      }
    } catch (error) {
      console.error("Error submitting product:", error);
    }
  };

  const handleFileChange = async (e) => {
    try {
      const files = Array.from(e.target.files);
      if (!files.length) return;

      const options = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 1280,
        initialQuality: 0.6,
        useWebWorker: true,
      };

      const compressedFiles = await Promise.all(
        files.map(async (file) => {
          const compressedBlob = await imageCompression(file, options);
          return new File([compressedBlob], file.name, { type: "image/jpeg" });
        })
      );

      setSelectedFiles(compressedFiles);
    } catch (error) {
      console.error("Compression Error:", error);
    }
  };

  // const compressFile = async (imageFile) => {
  //   try {
  //     if (!imageFile) return;

  //     console.time("Compression Time");
  //     const startTime = performance.now();

  //     const options = {
  //       maxSizeMB: 0.2,
  //       maxWidthOrHeight: 1280,
  //       initialQuality: 0.6,
  //       useWebWorker: true,
  //     };

  //     const compressedBlob = await imageCompression(imageFile, options);

  //     const compressedFile = new File([compressedBlob], imageFile.name, { type: "image/jpeg" });

  //     const endTime = performance.now();
  //     console.timeEnd("Compression Time");
  //     console.log(`Compression took: ${((endTime - startTime) / 1000).toFixed(2)} seconds`);

  //     console.log(`Original size: ${(imageFile.size / 1024).toFixed(2)} KB`);
  //     console.log(`Compressed size: ${(compressedFile.size / 1024).toFixed(2)} KB`);
  //     setSelectedFile(compressedFile); // Compressed file ko state me set karega
  //   } catch (error) {
  //     console.error("Compression Error:", error);
  //   }
  // };

  const handleExtract =  async () => {
    try {
      if (!selectedfiles.length) {
        return toast.error("Please select image");
      } else {
        setIsExtract(true);
        const file = selectedfiles[0]; // Extract from first selected image
        setIsExtractImage(true);

        const allowedFormats = ["image/jpeg", "image/jpg", "image/png"];
        const maxSize = 100 * 1024 * 1024;
        
        if (file) {
          if (!allowedFormats.includes(file.type)) {
            formRef.current.reset();
          } else if (file.size > maxSize) {
            toast.error("File size exceeds please select the corect size file");
            formRef.current.reset();
          } else {
            const reader = new FileReader();
            reader.onloadend = async () => {
              let base64 = reader?.result;

              let base64new = base64.replace(/^data:image\/\w+;base64,/, "");
              let response = await SparkApi.imageTextOpenAI({
                name: file.name,
                file: base64new,
                base64,
              });

              if (response.message === "Success") {
                setProducts((prev) => ({
                  ...prev,
                  name: response.data.productname,
                  description: response.data.description,
                  company_name: response.data.company_name,
                }));
                setIsExtract(false);
                setIsExtractImage(false);
              } else {
                setIsExtract(false);
                setIsExtractImage(false);
                toast.error(response.message);
              }
            };

            reader.readAsDataURL(file);
          }
        } else {
          setIsExtract(false);
          toast.error("Please Select Image.");
        }

      }
    } catch (error) {
      setIsExtract(false);
      setIsExtractImage(false);

      return toast.error("Failed to save product. Please try again.");
    }
  };

  return (
    <Container>
      {isExtractImage &&
        <div className="d-flex justify-content-center align-items-center create_product_spinner">
          <Oval
            visible={true}
            height="140"
            width="140"
            color="#275b6b"
            ariaLabel="oval-loading"
            wrapperClass=""
          />
        </div>
      }
      <Row>
        <Col />
        <Col lg={8} className="pb-1 pt-2">
          <Link className="nav-link" to="/products  ">
            Home <i className="fa-solid fa-chevron-right"></i>
            <span style={{ color: "#23468c", display: "inline" }}>
              {" "}
              Product{" "}
            </span>
          </Link>
        </Col>
        <Col />
      </Row>
      <Row>
        <Col />
        <Col lg={8}>
          <Form className="mt-3" >
            <Row className="view-form-header align-items-center">
              <Col lg={8} className="fs-5">
                {location?.state?.editProductData?.id ? "Edit " : "Create "}
                Product
              </Col>
              <Col lg={4} className="d-flex justify-content-end">
                <Button
                  disabled={disableButton}
                  className="btn-sm mx-2"
                  onClick={handleSubmit}
                >
                  {location?.state?.editProductData?.id ? "Update" : "Save"}
                </Button>
                <Button
                  className="btn-sm"
                  variant="danger"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
            <Row className="ibs-edit-form pb-3">
              <Row className="mb-3">
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicName">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="name"
                      placeholder="--Enter Product Name--"
                      value={products.name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  {productCategoriesOptions.length > 0 && (
                    <Form.Group className="mx-3">
                      <Form.Label>Product Category</Form.Label>
                      <Form.Select
                        name="category_id"
                        value={products?.category_id}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled selected>
                          -- Select product category --
                        </option>
                        {productCategoriesOptions.map((cat) => {
                          if (cat.status === "active") {
                            return (
                              <option key={cat.value} value={cat.value}>
                                {cat.label}
                              </option>
                            );
                          }
                          return null;
                        })}
                      </Form.Select>
                    </Form.Group>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicQuantity">
                    <Form.Label>Quantity</Form.Label>
                    <Form.Control
                      disabled
                      defaultValue={0}
                      type="number"
                      name="quantity"
                      placeholder="--Enter Product Quantity--"
                      value={products.quantity}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="type  ">
                    <Form.Label>Type</Form.Label>
                    <Form.Select
                      name="type"
                      value={products.type}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled selected>
                        -- Select Type --
                      </option>
                      <option value="solid">Solid</option>
                      <option value="gas">Gas</option>
                      <option value="liquid">Liquid</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={4} xs={10}>
                  <Form.Group className="mx-3">
                    <Form.Label>Images <small className="text-muted">(select one or more)</small></Form.Label>
                    <Form.Control
                      className="product-image-feild"
                      type="file"
                      name="image"
                      multiple
                      accept="image/*"
                      ref={formRef}
                      onChange={handleFileChange}
                    />
                    {selectedfiles.length > 0 && (
                      <div className="mt-1 text-muted" style={{ fontSize: "0.85em" }}>
                        {selectedfiles.length} image{selectedfiles.length > 1 ? "s" : ""} selected
                      </div>
                    )}
                    {products?.title && <div className="mx-3">{products.title}</div>}
                  </Form.Group>
                </Col>
                <Col lg={2}>
                  <Form.Group>
                    <Form.Label className="image-extract-label ms-3">Extract</Form.Label>
                    <Button
                      className="btn-sm mt-1 ms-3 extract-button"
                      onClick={handleExtract}
                      disabled={!selectedfiles.length}
                      >Extract</Button>
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="company_name">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="company_name"
                      placeholder="--Enter Company Name--"
                      value={products.company_name || ""}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicStatus">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      name="status"
                      value={products.status}
                      onChange={handleInputChange}
                    >
                      <option value="Available">Available</option>
                      <option value="Out of stock">Out of stock</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                {location.state?.name && (
                  <Col lg={6}>
                    <Form.Group className="mx-3" controlId="formBasicStatus">
                      <Form.Label>Rack</Form.Label>
                      <Form.Control
                        type="text"
                        name="quantity"
                        placeholder="Enter Product Rack"
                        value={location.state.name}
                      />
                    </Form.Group>
                  </Col>
                )}
                {/* <Row> */}
                <Col lg={12}>
                  <Form.Group className="mx-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="description"
                      placeholder="--Enter Product Description--"
                      value={products.description || ""}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                {/* </Row> */}
              </Row>
            </Row>
          </Form>
        </Col>
        <Col />
      </Row>
      <ToastContainer position="top-center" autoClose={1500} theme="light" />
    </Container>
  );
};

export default CreateProducts;  